import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import Dashboard from './pages/Dashboard';
import Menu from './pages/Menu';
import ProductDisplay from './pages/ProductDisplay';
import { Items } from './pages/Items';
import Venues from './pages/Venues';
import { Mealtimes } from './pages/Mealtimes/Mealtimes';
import { Mealtime } from './pages/Mealtime/Mealtime';
import { PriceSchemes } from './pages/PriceSchemes/PriceSchemes';
import { MenuPublicationStatus } from './pages/MenuPublicationStatus/MenuPublicationStatus';
import Menus from './pages/Menus';
import { PriceScheme } from './pages/PriceScheme/PriceScheme';
import { NotFound } from './components/NotFound';
import { ProductPublicationStatus } from './pages/ProductPublicationStatus/ProductPublicationStatus';
import { Routes } from './routes';
import Venue from './pages/Venue';
import { routerFutureFlags } from './constants';
import { Inventory } from './pages/Inventory';
import { InventoryItem } from './pages/InventoryItem';
import { OptionGroupDisplay } from './pages/OptionGroupDisplay/OptionGroupDisplay';
import { PublishSchedule } from './pages/PublishSchedule';
import { PublishHistory } from './pages/PublishHistory';
import { Timetables } from './pages/Timetables';
import { Timetable } from './pages/Timetable';

const Welcome = lazy(() => import('src/pages/Welcome'));
const Layout = lazy(() => import('src/components/Layout/Layout').then((module) => ({ default: module.LayoutWrapper })));

export const router = createBrowserRouter(
  [
    {
      id: 'root',
      element: <App />,
      children: [
        {
          path: Routes.LOGIN,
          element: <Welcome />,
        },
        {
          id: 'layout',
          path: Routes.DASHBOARD,
          element: <Layout />,
          children: [
            { index: true, element: <Dashboard /> },
            { path: Routes.MENUS, element: <Menus /> },
            { path: `${Routes.MENUS}/:menuId`, element: <Menu /> },
            { path: `${Routes.MENUS}/:menuId/status`, element: <MenuPublicationStatus /> },
            { path: `${Routes.MENUS}/:menuId/mealtimes`, element: <Mealtimes /> },
            { path: `${Routes.MENUS}/:menuId/mealtimes/:id`, element: <Mealtime /> },
            { path: `${Routes.MENUS}/:menuId/item/:itemId`, element: <ProductDisplay /> },
            { path: Routes.PRODUCT_LIBRARY, element: <Items /> },
            { path: `${Routes.PRODUCT_LIBRARY}/status/:eventId`, element: <ProductPublicationStatus /> },
            { path: `${Routes.PUBLISH_HISTORY}/status/:eventId`, element: <ProductPublicationStatus /> },
            { path: `${Routes.PRODUCT_LIBRARY}/:itemId`, element: <ProductDisplay /> },
            { path: Routes.INVENTORY, element: <Inventory /> },
            { path: `${Routes.INVENTORY}/:itemId`, element: <InventoryItem /> },
            { path: `${Routes.OPTION_GROUPS}/:optionGroupId`, element: <OptionGroupDisplay /> },
            { path: Routes.VENUES, element: <Venues /> },
            { path: `${Routes.VENUES}/:venueId`, element: <Venue /> },
            { path: Routes.PRICE_SCHEMES, element: <PriceSchemes /> },
            { path: `${Routes.PRICE_SCHEMES}/:priceSchemeId`, element: <PriceScheme /> },
            { path: Routes.PUBLISH_SCHEDULE, element: <PublishSchedule /> },
            { path: Routes.PUBLISH_HISTORY, element: <PublishHistory /> },
            { path: Routes.TIMETABLES, element: <Timetables /> },
            { path: `${Routes.TIMETABLES}/:timetableId`, element: <Timetable /> },
            { path: '*', element: <NotFound /> },
          ],
        },
      ],
    },
  ],
  {
    future: routerFutureFlags,
  },
);
